import React, { useState, useEffect, useContext } from "react";
import axios from "../../../../axios/index";

import { UserContext } from "../../../Context/UserContextProvider";

import { Link } from "react-router-dom";

// Styles
import styles from "./../Settings.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";
import { Pagination, Stack } from "@mui/material";
import CustomPagination from "../../../CustomPagination/CustomPagination";

const SettingContactMessages = () => {
  const { userToken } = useContext(UserContext);
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });
  const [isLoading, setIsLoading] = useState(true);

  const [contactMessagesData, setContactMessagesData] = useState();

  useEffect(() => {
    const dataHandler = async () => {
      const getContactedData = await axios.get("ContactUs", {
        headers: { authorization: "Bearer " + userToken },
      });
      const messages = getContactedData.data.data.data;
      setContactMessagesData(messages);
      setPage(prev => {
        return { ...prev, pageNumber: 1, pageCount: getContactedData.data.pageCount };
      });

      setIsLoading(false);
    };

    dataHandler();
  }, [userToken]);

  return (
    <>
      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div dir="rtl" className={`text-right mx-4 px-2 pt-2 pb-3 mt-4 mb-3`}>
          <div className={`d-flex align-items-center justify-content-between`}>
            <span className={`text-right col-2 ${styles.table_head_th}`}> شماره </span>
            <span className={`text-right col-4 ${styles.table_head_th}`}> نام و نام خانوادگی </span>
            <span className={`text-right col-4 ${styles.table_head_th}`}> زمان ثبت شده </span>
            <span className={`text-right col-2 ${styles.table_head_th}`}> جزئیات </span>
          </div>

          {contactMessagesData?.map(data => (
            <div key={data.id} className={`d-flex align-items-center justify-content-between my-3 py-4 px-2 ${styles.total_cols_tableBody}`}>
              <span className={`col-2 ${styles.table_th}`}> {data.id} </span>
              <span className={`text-right col-4 ${styles.table_th}`}>{data.fullName}</span>
              <span className={`d-flex align-items-center justify-content-start text-right col-4 ${styles.table_th}`}>
                {data.createDate?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
                {/* <div className={`mx-2 ${styles.rounded_gray}`}></div> */}
                {/* {data.date} */}
              </span>
              <span className={`col-2 ${styles.table_th}`}>
                <Link
                  to={{
                    pathname: `/setting-contact-messages-detail/${data.id}`,
                    state: data,
                  }}>
                  <span className={`${styles.link_detail_messages}`}> جزئیات بیشتر </span>
                  <img className={`pe-2 ${styles.consultantIconsTable}`} src={arrowBlue} alt="arrow-left-blue" width="22" />
                </Link>
              </span>
            </div>
          ))}

          <Stack
            className={Dstyles.pagination}
            spacing={1}
            sx={{
              direction: "ltr",
              bottom: "0",
              height: "85px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center !important",
            }}>
            <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
          </Stack>
        </div>
      )}
    </>
  );

  async function paginationHandler(event, value) {
    setIsLoading(true);
    const getContactedData = await axios.get(`ContactUs?PageId=${value}`, {
      headers: { authorization: "Bearer " + userToken },
    });
    const messages = getContactedData.data.data.data;
    setContactMessagesData(messages);
    setPage(prev => {
      return { ...prev, pageCount: getContactedData.data.data.pageCount, pageNumber: value };
    });
    setIsLoading(false);
  }
};

export default SettingContactMessages;
